export function getAdObjectByKey(pathname: string | null, object: any) {
  if (!pathname) return null
  const isPathWithAd = Object.keys(object).includes(pathname)
  return isPathWithAd ? object[pathname as keyof typeof object] : null
}
